export const WorkspaceKey_FHIRSandbox = 'workspace-key--advisor-fhir-sandbox';
export const WorkspaceConfig_FHIRSandbox = {
    name: 'Horizontal Space',
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            { name: 'LeftPanel', key: 'queries', visible: true, min: 300, factor: 3 / 5 },
            { name: 'RightPanel', key: 'history', visible: true, min: 300, factor: 2 / 5 },
        ]
    }
};
//# sourceMappingURL=workspace.js.map